import React from 'react'

function PageFooter() {
    return (
        <div className="page-footer">
            {"\u00A9 "} Copyright 2026 by Eighth-Eighth, LLC
        </div>
    )
}

export default PageFooter
